import { Component, Input } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

@Component({
    selector: 'app-loan-datepicker',
    templateUrl: './loan-datepicker.component.html',
    styleUrl: './loan-datepicker.component.scss',
    standalone: false
})
export class LoanDatepickerComponent {
    @Input({ required: true }) control!: FormControl;
    @Input({ required: true }) label: string = '';
    @Input() placeholder: string = '';
    @Input() required: boolean = false;

    get isRequired(): boolean {
        return this.required || this.control.hasValidator(Validators.required);
    }
}
